module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-1-3.fdb3f2a6.png";